import { render, staticRenderFns } from "./account-part-add-or-update.vue?vue&type=template&id=156f7de8&scoped=true"
import script from "./account-part-add-or-update.vue?vue&type=script&lang=js"
export * from "./account-part-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./account-part-add-or-update.vue?vue&type=style&index=0&id=156f7de8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156f7de8",
  null
  
)

export default component.exports